import { type GetAccountsByAaIDResponse, OutboundAuthApiError } from './types';

/**
 * AaidAaidGet
 * Fetches all containers and their services/accounts for a given Atlassian Account ID
 * https://bitbucket.org/atlassian/outbound-auth/src/master/src/route/getAccountsForAaID.ts
 * @param aaid - Atlassian Account ID
 * @returns Promise<GetAccountsByAaIDResponse> - The API response with all containers
 */
export const fetchAccountsByAaIdInternal = async (
	aaid: string,
): Promise<GetAccountsByAaIDResponse> => {
	const url = `/gateway/api/outbound-auth/aaId/${aaid}`;

	const response = await fetch(url, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	});

	if (!response.ok) {
		throw new OutboundAuthApiError('Failed to fetch accounts by aaId');
	}

	return (await response.json()) as GetAccountsByAaIDResponse;
};
